<template>
  <div>
    <div class="text-weight-bold">Categoria</div>
    <q-select
      v-model="categoria"
      :options="listaCategoria"
      @filter="filterFn"
      @input-value="setModel"
      use-input
      dense
      outlined
      option-label="nome"
      option-value="uuid"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhuma categoria encontrada
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps } from "vue";
import { useStore } from "vuex";

const emit = defineEmits(["enviarCategoria"]);
const props = defineProps(["resetar", "tipoCategoriaUuid", "model"]);
const time = ref();
const store = useStore();

const categoria = ref(props.model);
const listaCategoria = ref([]);

const listarCategorias = async (val) => {
  try {
    const response = await store.dispatch("documento/listarCategorias", {
      unidadeId: store.state.org.unidadeData.id,
      perPage: 100,
      nome: val,
    });
    listaCategoria.value = response.data.resultado.dados;
  } catch (error) {
    console.log(error);
  }
};

const buscarCategoria = async () => {
  if (props.tipoCategoriaUuid == "") {
    return;
  }
  try {
    const response = await store.dispatch("documento/listarCategorias", {
      unidadeId: store.state.org.unidadeData.id,
      perPage: 100,
      categoriaUuid: props.tipoCategoriaUuid,
    });
    categoria.value = response.data.resultado.dados[0];
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => categoria.value,
  () => {
    emit("enviarCategoria", categoria.value);
  }
);

watch(
  () => props.resetar,
  () => {
    categoria.value = "";
  }
);

watch(
  () => props.model,
  () => {
    categoria.value = props.model;
  }
);

watch(
  () => props.tipoCategoriaUuid,
  () => {
    if (
      props.tipoCategoriaUuid != "" &&
      props.tipoCategoriaUuid != null &&
      props.tipoCategoriaUuid != undefined
    ) {
      buscarCategoria();
    }
  }
);

function filterFn(val, update, abort) {
  clearTimeout(time.value);
  if (val.length < 1) {
    abort();
    return;
  }

  time.value = setTimeout(() => {
    listarCategorias(val);
  }, 2000);

  setTimeout(() => {
    update();
  }, 2500);
}

function setModel(val) {
  if (val === "") {
    categoria.value = val;
  }
}
</script>
